import { Select as SelectKey } from 'chakra-react-select';
import React from 'react';
import { useController } from 'react-hook-form';
import { FormControl, FormLabel } from '../..';
export function MultiSelect({ name, options, control, labelText, rules, ...rest }) {
    const { field: { onChange, onBlur, value, ref } } = useController({
        control,
        name,
        rules: rules
    });
    return (React.createElement(FormControl, null,
        labelText && (React.createElement(FormLabel, { htmlFor: name, id: name + 'label', key: name + 'label' }, labelText)),
        React.createElement(SelectKey, { isMulti: true, name: name, ref: ref, options: options, onChange: onChange, onBlur: onBlur, value: value, closeMenuOnSelect: false, styles: {
                menuPortal: (provided) => ({ ...provided, zIndex: 100 })
            }, "aria-labelledby": name + 'label', ...rest })));
}
